export default __webpack_public_path__ + "dde5d4964b94a52325f62bef14a637aa.svg";